import angular from 'angular';
import '../resources/resource';
import '../resources/place';
import '../resources/capacity';

const module = angular.module('whyline.services.capacity', [
  'whyline.resources.resource',
  'whyline.resources.capacity',
]);

let Resource;
let Capacity;

class CapacityService {

  static $inject = ['Resource', 'Capacity'];

  constructor(injectedResource, injectedCapacity) {
    Resource = injectedResource;
    Capacity = injectedCapacity;
  }

  restart() {
    return Resource.RestartCache();
  }

  GetEntries() {
    return Capacity.GetEntries();
  }

  Entrance(entryId) {
    return Capacity.Entrance(entryId);
  }

  Exit(bulkExit) {
    return Capacity.Exit(bulkExit);
  }

  Cancel(id) {
    return Capacity.Cancel(id);
  }

  SendNotification(entries) {
    return Capacity.SendNotification(entries);
  }

  AddPhysicalEntries(entries) {
    return Capacity.AddPhysicalEntries(entries);
  }

  GetModalInfoFromServer(entryId) {
    return Capacity.GetModalInfoFromServer(entryId);
  }

  GetNotificationsBySubscriptionId(entryId) {
    return Capacity.GetNotificationsBySubscriptionId(entryId);
  }

  SendFreeSMS(body) {
    return Capacity.SendFreeSMS(body);
  }

  SendDefaultSMS(body) {
    return Capacity.SendDefaultSMS(body);
  }
}

module.exports = module.service('CapacityService', CapacityService);
